import { FormControl, FormGroup } from '@angular/forms';
import {
  InputCheckboxListOption,
  InputSelectOptionInterface,
} from '../../../../../../types/interfaces/input.interface';

export abstract class ColumnStepBase {
  abstract column: InputCheckboxListOption[];

  protected form: FormGroup = new FormGroup({
    list: new FormControl<string[]>([], {nonNullable: true}),
  });

  protected constructor(selectedColumns: string[]){
    this.form.get('list')
      ?.setValue(selectedColumns);
  }


  public getForm(): FormGroup {
    return this.form;
  }

  public getSelectedColumns(): string[] {
    return this.form.get('list')?.value ?? [];
  }
}
